module.exports = __webpack_public_path__ + "img/oursolution7.eadb6239.png";